import { useTranslate } from "@similarweb/i18n-provider";
import type { IButtonProps } from "@similarweb/ui-components";

import { GaConnectTexts } from "../texts";

import { GAButton, GAIcon, GAContainer } from "./styles";

export const GaConnectButton = (props: Omit<IButtonProps, "type" | "children">) => {
    const { translate } = useTranslate();

    return (
        <GAContainer>
            <GAIcon
                iconName="ga-icon"
                size="xs"
            />
            <GAButton
                type="outlined"
                label={translate(GaConnectTexts.gaConnectButtonLabel)}
                {...props}
            />
        </GAContainer>
    );
};
